import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import { PASSWORD_INPUT, SIGNUP_PATHS } from '../../../../constants';
import { useUserToken } from '../../../../hooks/userTokenHook';
import IconBtn from '../../../../modules/icon-btn/icon-btn';
import UiInput from '../../../../modules/ui/ui-input/ui-input';
import { useAppDispatch } from '../../../../store';
import { setPush } from '../../../../store/actions/app';
import { setProfilePassword } from '../../../../store/actions/signup';
import { RootState } from '../../../../types';
import FormFooter from '../form-footer/form-footer';
import FormHeader from '../form-header/form-header';
import UserIcon from '../icons/user-icon.svg';
import EyeIcon from './icons/eye-icon.svg';
import { isPasswordStrong } from 'utils';

const PasswordStep: React.FC = () => {
  const { token } = useUserToken();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const step = useSelector((s: RootState) => s.signup.step);
  const loadingSetPassword = useSelector(
    (s: RootState) => s.signup.loading.setPassword
  );

  const [validateOnChange, setValidateOnChange] = useState(false);

  const formState = useFormik({
    initialValues: {
      password: '',
      repeatPassword: '',
    },
    validateOnChange: validateOnChange,
    validateOnBlur: false,
    validate: (values) => {
      const errors: Record<string, string> = {};

      if (!isPasswordStrong(values.password)) {
        errors.password = 'Пароль не соответствует требованиям безопасности';
      }

      if (values.password !== values.repeatPassword) {
        errors.repeatPassword = 'Пароли не совпадают';
      }

      return errors;
    },
    onSubmit: (values) => {
      dispatch(setProfilePassword({ password: values.password })).then(
        (action) => {
          if (action.meta.requestStatus === 'fulfilled') {
            dispatch(
              setPush({
                message: 'Регистрация прошла успешно',
                type: 'success',
              })
            );
            history.push(SIGNUP_PATHS.VERIFICATION);
          }
        }
      );
    },
  });

  useEffect(() => {
    if (!token) history.push(SIGNUP_PATHS.CODE);

    if (step && step !== 'PASSWORD_CREATION') {
      history.push(SIGNUP_PATHS.NEW);
    }
  }, []);

  return (
    <form className="login-form login-form--9">
      <FormHeader
        bigTitle="Регистрация"
        title="Придумайте пароль"
        text={
          <>
            Пароль должен содержать минимум 8 знаков, состоять <br />
            из строчных и заглавный букв и цифр
          </>
        }
      />
      <div className="login-form__body">
        <div className="login-form__container-296">
          <div className="mb_24">
            <UiInput
              rightIcon={EyeIcon}
              lg
              error={formState.errors.password && formState.touched.password}
              type={PASSWORD_INPUT}
              value={formState.values.password}
              name="password"
              onChange={formState.handleChange}
              onInputBlur={formState.handleBlur}
            />
            {formState.errors.password && (
              <p className="p p_font-size_12 p_color_red mt_4">
                {formState.errors.password}
              </p>
            )}
          </div>
          <div className="login-form__item-input">
            <UiInput
              rightIcon={EyeIcon}
              error={
                formState.errors.repeatPassword &&
                formState.touched.repeatPassword
              }
              value={formState.values.repeatPassword}
              type={PASSWORD_INPUT}
              name="repeatPassword"
              onChange={formState.handleChange}
              onInputBlur={formState.handleBlur}
              lg
            />
            {formState.errors.repeatPassword && (
              <p className="p p_font-size_12 p_color_red mt_4">
                {formState.errors.repeatPassword}
              </p>
            )}
          </div>
        </div>
      </div>
      <FormFooter
        actions={
          <IconBtn
            disabled={
              loadingSetPassword ||
              !formState.values.password ||
              !formState.values.repeatPassword
            }
            onClick={() => {
              setValidateOnChange(true);
              formState.handleSubmit();
            }}
            icon={UserIcon}
            title="Продолжить"
            lg
          />
        }
      />
    </form>
  );
};

export default PasswordStep;
